import type { Brand } from "@shared/brand.types";
import type { ReactNode } from "react";
import { brandToCssVars } from "@/lib/brand";

/**
 * Applique la marque de l'école en surchargeant les tokens, et rien d'autre.
 *
 * Les variables sont posées sur un élément, pas sur `:root` : deux marques peuvent
 * coexister dans une même page, ce que la prévisualisation côté école demande.
 */
export function BrandRoot({
	brand,
	children,
	className = "",
}: {
	brand: Brand;
	children: ReactNode;
	className?: string;
}) {
	return (
		<div style={brandToCssVars(brand)} className={`font-brand ${className}`}>
			{children}
		</div>
	);
}
